export const INFO_PANE_PAGES = {
  'patient_page': 'patient_page',
  'metrics': 'metrics',
  'program': 'program',
};
